import styled from "styled-components";
import {styledByDevice} from "../../../../../themes/architecture/styled-by-device";
import {ACTIVE} from "../../../../../themes/css-global-classes";
import {CssRule} from "../../../../../themes/architecture/css-helpers/css-rule";

const PCBox = styled.span`
    background-image: url("${props => props.theme.images.spriteSheet.toString()}");
    background-repeat: no-repeat;
    background-position: -364px -553px;
    width: 20px;
    height: 21px;
    margin-right: 10px;
    cursor: pointer;
    
    .${ACTIVE} &{
        background-position: -396px -553px;
    }
`;

const MobileBox= styled.span`
    position: relative;
    background: ${props => props.theme.colors.backgroundLight};
    border-radius: 50%;
    padding: 50px;
    
    @media ${({theme}) => theme.mediaQuery.sAndBelow} {
        padding: 40px;
    }
    
     ${CssRule.For.mobile.landscape.build()} & {
   grid-template-columns: repeat(5, 130px);
  }

    &:before {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      width: 30px;
      height: 30px;
      background-image: url("${props => props.theme.images.spriteSheet.toString()}");
      background-repeat: no-repeat;
      background-position: -204px -358px;
      transform: translate(-50%, -50%);
    }
 
    
    .${ACTIVE} &{
        background: ${props => `linear-gradient(${props.theme.colors.brandSecondaryDark}, ${props.theme.colors.brandSecondaryLight}, ${props.theme.colors.brandPrimaryDark})`};

        &:before {
          background-position: -95px -358px;
        }
    
        :after {
          content: "";
          position: absolute;
          left: 0;
          bottom: 0;
          width: 30px;
          height: 30px;
          background-image: url("${props => props.theme.images.spriteSheet.toString()}");
          background-repeat: no-repeat;
          background-position: -544px -516px;
          border-radius: 50%;
        }
    }
`;

export const FilterLinkIconDefaultBox = styledByDevice(PCBox, MobileBox);
